import { fork } from 'redux-saga/effects';

import { actions, selectors } from 'domain/medium';
import { listNavigator } from 'sagas/common';
import { filters } from 'filters/medium';

export default function* navigator() {
  yield fork(listNavigator, { modelName: 'Medium', actions, selectors, filters } );
}
